import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'translation'

AdminRouter.addRoutes([
  {
    path: `/${base}`,
    name: base,
    component: () => import('./Index.vue'),
    meta: {
      auth: true,
    },
  },
])

AdminSidebar.pushItem({
  id: `${base}`,
  order: 200,
  header: $vm => $vm.$t(`general.menu_settings`),
  text: $vm => $vm.$t(`translation.translations`),
  route: {
    name: `${base}`,
  },
  icon: 'icon-earth',
  permission: 'translations.manage',
})

messageGroups.push(base)
